import React, { useEffect, useRef } from "react";
import CustomSelect from "../Custom/CustomSelect";
import useDropdownData from "../../../hooks/useDropdownData";
import { useLoginUser } from "../../../hooks/useLoginUser";

const DynamicSelect = ({
  type,
  placeholder,
  size,
  rounded,
  selected,
  onChange,
  showSearch,
  showButton,
  disabled,
  multiple,
  parentValue, // Add this prop for citiesState
  ret,
  refCollection,
  onSelectItem,
  placementUiid,
  entityType,
  showNames,
  filters,
  shadow,
  showClearButton,
}) => {
  const containerRef = useRef(null);
  const { userData: loginUserData } = useLoginUser();
  const organizationId = loginUserData?.organizationId.uiid;
  const [updateSelectedValue, setUpdateSelectedValue] = React.useState(null); // Add this state for selectedValue

  const { data: countryOptions } = useDropdownData("countriesUsAndCanada");
  // For city-state, we need to depend on the selected country
  const countryId =
    parentValue && typeof parentValue === "object" && parentValue.country
      ? countryOptions.find((item) => item.label === parentValue.country)?.id
      : undefined;

  let apiType = type;
  let alertName = null;

  switch (type) {
    case "jobTitle":
      apiType = "jobTitles";
      alertName = "addJobTitles";
      break;
    case "atsJobTitle":
      apiType = "atsJobTitles";
      alertName = "addAtsJobTitle";
      break;
    case "roleType":
      apiType = "roleTypes";
      alertName = "addRoleTypes";
      break;
    case "financeManager":
      apiType = "financeManager";
      break;
    case "hrManager":
      apiType = "hiringManager";
      break;
    case "immigrationManager":
      apiType = "immigrationManager";
      break;
    case "countriesUsAndCanada":
      apiType = "countriesUsAndCanada";
      break;
    case "countries":
      apiType = "countries";
      break;
    case "documentTypes":
      apiType = "documentTypes";
      alertName = "addDocumentType";
      break;
    case "eVerifiedBy":
      apiType = "eVerifiedBy";
      break;
    case "allClientsList":
      apiType = "allClientsList";
      break;
    case "employees":
      apiType = "employees";
      break;
    case "employeesConsultantFullNames":
      apiType = "employeesConsultantFullNames";
      break;
    case "states":
      apiType = "states";
      alertName = "states"
      break;
    case "cities":
      apiType = "cities";
      alertName = "cities"
      break
    case "citiesState":
      apiType = "citiesState";
      break;
    case "atscitiesState":
      apiType = "atscitiesState";
      break;
    case "netTerm":
      apiType = "netTerms";
      alertName = "addNetTerms";
      break;
    case "clientCategory":
      apiType = "clientCategories";
      alertName = "addClientCategories";
      break;
    case "jobTerminationNotice":
      apiType = "jobTerminationNotices";
      alertName = "addJobTerminationNotices";
    case "contactType":
      apiType = "contactTypes";
      alertName = "addContactTypes";
      break;
    case "employeeClients":
      apiType = "employeeClients";
      break;
    case "employeePlacements":
      apiType = "employeePlacements";
      break;
    case "placementsList":
      apiType = "placementsList";
      alertName = "addPlacementsList";
      break;
    case "employeesSorted":
      apiType = "employeesSorted";
      break;
    case "employeesSortedOnboarding":
      apiType = "employeesSortedOnboarding";
      break;
    case "employeesSortedNonBillable":
      apiType = "employeesSortedNonBillable";
      break;
    case "employeesSortedWithoutRef":
      apiType = "employeesSortedWithoutRef";
      break;
    case "placementsForTimesheetsAdd":
      apiType = "placementsForTimesheetsAdd";
      break;
    case "allVendorsList":
      apiType = "allVendorsList";
      break;
    case "allVendorsListOnboarding":
      apiType = "allVendorsListOnboarding";
      break;
    case "placements":
      apiType = "placements";
    case "placementsWithEmployeeName":
      apiType = "placementsWithEmployeeName";
      break;
    case "placementsForPayConfigDropDown":
      apiType = "placementsForPayConfigDropDown";
      break;
    case "allClientsSorted":
      apiType = "allClientsSorted";
      break;
    case "clientsSortedOnboarding":
      apiType = "clientsSortedOnboarding";
      break;
    case "allPayProfiles":
      apiType = "allPayProfiles";
      break;
    case "clientsWithPlacements":
      apiType = "clientsWithPlacements";
      break;
    case "allEmployees":
      apiType = "allEmployees";
      break;
    case "allEmployees4Type":
      apiType = "allEmployees4Type";
      break;
    case "employeeWithPlacement":
      apiType = "employeeWithPlacement";
      break;

    case "deductions":
      apiType = "deductions";
      alertName = "addDeductions";
      break;
    case "expensesTypes":
      apiType = "expensesTypes";
      alertName = "addExpensesTypes";
      break;
    case "paymentMethods":
      apiType = "paymentMethods";
      alertName = "addPaymentMethods";
      break;
    case "depositTo":
      apiType = "depositTo";
      alertName = "addDepositTo";
      break;
    case "industry":
      apiType = "industry";
      alertName = "addIndustry";
      break;
    case "allTimesheetClients":
      apiType = "allTimesheetClients";
      break;
    case "allInvoiceClients":
      apiType = "allInvoiceClients";
      break;
    case "atsRoles":
      apiType = "atsRoles";
      break;
    case "benchsalesRoles":
      apiType = "benchsalesRoles";
      break;
    case "allCompanies":
      apiType = "allCompanies";
      break;
    case "allUsers":
      apiType = "allUsers";
      break;
    case "getJobBoardUsers":
      apiType = "getJobBoardUsers";
      break;
    case "getJobBoardUsersBs":
      apiType = "getJobBoardUsersBs";
      break;
    case "getCandidateAuthEmailsBs":
      apiType = "getCandidateAuthEmailsBs";
      break;
    case "companiesSearch":
      apiType = "companiesSearch";
      break;
    case "workforceRoles":
      apiType = "workforceRoles";
      break;
    case "users":
      apiType = "users";
      break;
    case "bdmAndRecruiters":
      apiType = "bdmAndRecruiters";
      break;
    case "bdmAndRecruitersUsers":
      apiType = "bdmAndRecruitersUsers";
      break;
    case "AllBdmRecruiters":
      apiType = "AllBdmRecruiters";
      break;
    case "AllRecruiters":
      apiType = "AllRecruiters";
      break;
    case "onlyBDMUsers":
      apiType = "onlyBDMUsers";
      break;
    case "bdmManagers":
      apiType = "bdmManagers";
      break;
    case "bdmUsers":
      apiType = "bdmUsers";
      break;
    case "emailSourceAccounts":
      apiType = "emailSourceAccounts";
      break;
    case "emailSourceAccountsBs":
      apiType = "emailSourceAccountsBs";
      break;
    case "candidateAuthEmails":
      apiType = "candidateAuthEmails";
      break;
    case "templates":
      apiType = "templates";
      break;
    case "getCampaignAccounts":
      apiType = "getCampaignAccounts";
      break;
    case "getWorkSpaceUsers":
      apiType = "getWorkSpaceUsers";
      break;
    case "allPdfTemplatesNames":
      apiType = "allPdfTemplatesNames";
      break;
    case "usersForEonboarding":
      apiType = "usersForEonboarding";
      break;
    case "checklistsWithEntityFilter":
      apiType = "checklistsWithEntityFilter";
      break;
    case "bs_email_templates":
      apiType = "bs_email_templates";
      break;
    case "bs_candidate_email_templates":
      apiType = "bs_candidate_email_templates";
      break;
    case "bs_company_name":
      apiType = "bs_company_name";
      alertName = "addCompanyName";
      break;
    case "aiCallAssistants":
      apiType = "aiCallAssistants";
      break;
      
    default:
      apiType = type;
      break;
  }

  // Define hook parameters using a switch statement
  let hookParams;

  switch (type) {
    case "jobTitle":
      // For jobTitle, just pass the type
      hookParams = [apiType];
      break;
    case "atsJobTitle":
      // For jobTitle, just pass the type
      hookParams = [apiType];
      break;

    case "citiesState":
    case "states":
    case "atscitiesState":
      // For citiesState, pass countryList and countrySearch
      hookParams = [
        apiType,
        10,
        { countryList: parentValue.country },
        { countrySearch: countryId },
      ];
      break;

    case "cities":
      // For cities, pass stateList and stateSearch
      hookParams = [
        apiType,
        10,
        // { stateList: parentValue },
        // { stateSearch: parentId },
        { country: parentValue.country, state: parentValue.state },
        { countrySearch: countryId, stateSearch: parentValue.state },
      ];
      break;
    case "netTerm":
      // For jobTitle, just pass the type
      hookParams = [apiType];
      break;
    case "industry":
      // For jobTitle, just pass the type
      hookParams = [apiType];
      break;
    case "deductions":
      // For jobTitle, just pass the type
      hookParams = [apiType];
      break;
    case "expensesTypes":
      // For jobTitle, just pass the type
      hookParams = [apiType];
      break;
    case "clientCategory":
      // For jobTitle, just pass the type
      hookParams = [apiType];
      break;
    case "jobTerminationNotice":
      // For jobTitle, just pass the type
      hookParams = [apiType];
      break;
    case "contactType":
      // For jobTitle, just pass the type
      hookParams = [apiType];
      break;
    case "placementsList":
      // For jobTitle, just pass the type
      hookParams = [apiType];
      break;
    case "placements":
    case "placementsWithEmployeeName":
    case "placementsForPayConfigDropDown":
      hookParams = [
        apiType,
        10,
        { entityId: parentValue.entityId, entityType: parentValue.entityType },
        { entityId: parentValue.entityId, entityType: parentValue.entityType },
      ];
      break;
    default:
      // Default parameters for other types
      hookParams = [
        apiType,
        5,
        {},
        {
          orgId: organizationId,
          ret: ret,
          ref: refCollection,
          placementUiid,
          entityType,
          showNames: showNames,
          ...filters,
        },
      ];
      break;
  }
  // Use the spread operator to pass the parameters to useDropdownData
  const {
    data: options,
    searchValue: searchValue,
    handleSearch: handleSearch,
    resetSearch: resetSearch,
    handleScroll: handleScroll,
    originalData: fetchedOriginalData,
  } = useDropdownData(...hookParams);
  useEffect(() => {
    // Reset the search value when the parentValue changes
    //alert("parentValue", parentValue);

    const selectedValue = options.find((option) => option.value === selected);
    setUpdateSelectedValue(selectedValue);
  }, [onChange]);

  // Create a wrapper for the onChange function to pass the full option object
  const handleChange = (value) => {
    // Find the selected option with its label
    const selectedOption = options.find((option) => option.value === value);
    // If we found the option, pass both value and label to parent
    if (selectedOption) {
      onChange(selectedOption); // Pass the full option object instead of just the value
    } else {
      // Fallback to just passing the value if option not found
      onChange(value);
    }
  };
  return (
    <>
      {/* {parentValue && parentValue}
      {parentId && parentId} */}
      <CustomSelect
        placeholder={placeholder}
        size={size}
        rounded={rounded}
        options={options}
        selected={selected}
        onChange={handleChange}
        showSearch={showSearch}
        showButton={showButton}
        alertName={alertName}
        icon={"add"}
        disabled={disabled}
        handleScroll={() => handleScroll(containerRef)}
        refData={containerRef}
        keyname={apiType}
        searchValue={searchValue}
        onSearch={handleSearch}
        onClose={resetSearch}
        multiple={multiple}
        fetchedOriginalData={fetchedOriginalData}
        onSelectItem={onSelectItem}
        shadow={shadow}
        showClearButton={showClearButton}
      />
    </>
  );
};

export default DynamicSelect;

// import React, { useEffect, useRef } from "react";
// import CustomSelect from "../Custom/CustomSelect";
// import useDropdownData from "../../../hooks/useDropdownData";
// import { useLoginUser } from "../../../hooks/useLoginUser";

// const DynamicSelect = ({
//   type,
//   placeholder,
//   size,
//   rounded,
//   selected,
//   onChange,
//   showSearch,
//   showButton,
//   disabled,
//   multiple,
//   parentValue, // Add this prop for citiesState
// }) => {
//   const containerRef = useRef(null);
//   const { userData: loginUserData } = useLoginUser();
//   const organizationId = loginUserData?.organizationId.uiid;
//   const [updateSelectedValue, setUpdateSelectedValue] = React.useState(null); // Add this state for selectedValue

//   const { data: countryOptions } = useDropdownData("countriesUsAndCanada");
//   // For city-state, we need to depend on the selected country
//   const countryId =
//     parentValue && typeof parentValue === "object" && parentValue.country
//       ? countryOptions.find((item) => item.label === parentValue.country)?.id
//       : undefined;

//   let apiType = type;
//   let alertName = null;

//   switch (type) {
//     case "jobTitle":
//       apiType = "jobTitles";
//       alertName = "addJobTitles";
//       break;
//     case "roleType":
//       apiType = "roleTypes";
//       alertName = "addRoleTypes";
//       break;
//     case "financeManager":
//       apiType = "financeManager";
//       break;
//     case "hrManager":
//       apiType = "hiringManager";
//       break;
//     case "immigrationManager":
//       apiType = "immigrationManager";
//       break;
//     case "countriesUsAndCanada":
//       apiType = "countriesUsAndCanada";
//       break;
//     case "countries":
//       apiType = "countries";
//       break;
//     case "documentTypes":
//       apiType = "documentTypes";
//       alertName = "addDocumentType";
//       break;
//     case "eVerifiedBy":
//       apiType = "eVerifiedBy";
//       break;
//     case "allClientsList":
//       apiType = "allClientsList";
//       break;
//     case "employees":
//       apiType = "employees";
//       break;
//     case "employeesConsultantFullNames":
//       apiType = "employeesConsultantFullNames";
//       break;
//     case "states":
//       apiType = "states";
//       break;
//     case "cities":
//       apiType = "cities";
//       break;
//     case "citiesState":
//       apiType = "citiesState";
//       break;
//     case "netTerm":
//       apiType = "netTerms";
//       alertName = "addNetTerms";
//       break;
//     case "clientCategory":
//       apiType = "clientCategories";
//       alertName = "addClientCategories";
//       break;
//     case "jobTerminationNotice":
//       apiType = "jobTerminationNotices";
//       alertName = "addJobTerminationNotices";
//     case "contactType":
//       apiType = "contactTypes";
//       alertName = "addContactTypes";
//       break;
//     default:
//       break;
//   }

//   // Define hook parameters using a switch statement
//   let hookParams;

//   switch (type) {
//     case "jobTitle":
//       // For jobTitle, just pass the type
//       hookParams = [apiType];
//       break;

//     case "citiesState":
//     case "states":
//       // For citiesState, pass countryList and countrySearch
//       hookParams = [
//         apiType,
//         10,
//         { countryList: parentValue.country },
//         { countrySearch: countryId },
//       ];
//       break;

//     case "cities":
//       // For cities, pass stateList and stateSearch
//       hookParams = [
//         apiType,
//         10,
//         // { stateList: parentValue },
//         // { stateSearch: parentId },
//         { country: parentValue.country, state: parentValue.state },
//         { countrySearch: countryId, stateSearch: parentValue.state },
//       ];
//       break;
//     case "netTerm":
//       // For jobTitle, just pass the type
//       hookParams = [apiType];
//       break;
//     case "clientCategory":
//       // For jobTitle, just pass the type
//       hookParams = [apiType];
//       break;
//     case "jobTerminationNotice":
//       // For jobTitle, just pass the type
//       hookParams = [apiType];
//       break;
//     case "contactType":
//       // For jobTitle, just pass the type
//       hookParams = [apiType];
//       break;
//     default:
//       // Default parameters for other types
//       hookParams = [apiType, 5, {}, { orgId: organizationId }];
//       break;
//   }

//   // Use the spread operator to pass the parameters to useDropdownData
//   const {
//     data: options,
//     searchValue: searchValue,
//     handleSearch: handleSearch,
//     resetSearch: resetSearch,
//     handleScroll: handleScroll,
//   } = useDropdownData(...hookParams);

//   useEffect(() => {
//     // Reset the search value when the parentValue changes
//     //alert("parentValue", parentValue);

//     console.log("selected", selected);

//     const selectedValue = options.find((option) => option.value === selected);

//     setUpdateSelectedValue(selectedValue);
//     console.log("selectedValue", selectedValue);
//   }, [onChange]);

//   // Create a wrapper for the onChange function to pass the full option object
//   const handleChange = (value) => {
//     // Find the selected option with its label
//     const selectedOption = options.find((option) => option.value === value);

//     // If we found the option, pass both value and label to parent
//     if (selectedOption) {
//       onChange(selectedOption); // Pass the full option object instead of just the value
//     } else {
//       // Fallback to just passing the value if option not found
//       onChange(value);
//     }
//   };

//   return (
//     <>
//       {/* {parentValue && parentValue}
//       {parentId && parentId} */}
//       <CustomSelect
//         placeholder={placeholder}
//         size={size}
//         rounded={rounded}
//         options={options}
//         selected={selected}
//         onChange={handleChange} // Use our wrapper function instead of passing onChange directly
//         showSearch={showSearch}
//         showButton={showButton}
//         alertName={alertName}
//         icon={"add"}
//         disabled={disabled}
//         handleScroll={() => handleScroll(containerRef)}
//         refData={containerRef}
//         keyname={apiType}
//         searchValue={searchValue}
//         onSearch={handleSearch}
//         onClose={resetSearch}
//         multiple={multiple}
//       />
//     </>
//   );
// };

// export default DynamicSelect;
